
    import '/mnt/src/components/Grid/index.md?watch=parent';
    export const demoIndex = {
  ids: ["grid-demo-basic","grid-demo-gap","grid-demo-offset"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Grid/index.md?type=demo')
};